import React from 'react';
import { ui } from '../ui';

export function SectionHead({
  title,
  count,
  hint,
}: {
  title: string;
  count: number;
  hint?: string;
}) {
  return (
    <div className="mb-3">
      <div className="flex items-baseline gap-2">
        <h3 className={`m-0 ${ui.subhead}`}>{title}</h3>
        <span className={ui.muted}>{count}</span>
      </div>
      {hint && <p className={`m-0 mt-1 ${ui.muted}`}>{hint}</p>}
    </div>
  );
}
